// Theme: auto (follow system) → light → dark. The head script stamps
// data-theme before first paint; this just manages the cycle and live
// system-preference changes.

import { storage } from "../lib/storage";
import { toast } from "./toast";

const THEME_ICONS: Record<string, string> = { auto: "◐ auto", light: "☀ light", dark: "☾ dark" };

function themePref(): string { return storage.get("lattice.theme") || "auto"; }

export function applyTheme(): void {
  const pref = themePref();
  const dark = pref === "auto" ? matchMedia("(prefers-color-scheme: dark)").matches : pref === "dark";
  document.documentElement.dataset.theme = dark ? "dark" : "light";
  const btn = document.getElementById("themeBtn");
  if (btn) btn.textContent = THEME_ICONS[pref] ?? THEME_ICONS.auto!;
}

export function cycleTheme(): void {
  const next = ({ auto: "light", light: "dark", dark: "auto" } as Record<string, string>)[themePref()] ?? "auto";
  storage.set("lattice.theme", next);
  applyTheme();
  toast(`theme: ${next}${next === "auto" ? " (follows your system)" : ""}`);
}

export function initTheme(): void {
  applyTheme();
  matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => { if (themePref() === "auto") applyTheme(); });
}
